/** The browser tab of the admin (WP-25): «Выплаты — Aivy Admin», so ten open tabs can be told
 *  apart. No counts in the title («(3) Выплаты» was dropped in review: the rail shows them). */
import { useEffect } from 'react'

export const ADMIN_TITLE = 'Aivy Admin'

/** «Раздел — Aivy Admin»; without a section just «Aivy Admin». */
export function documentTitle(section?: string | null): string {
  return section ? `${section} — ${ADMIN_TITLE}` : ADMIN_TITLE
}

/** Sets `document.title` while the caller is mounted with this title. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title
  }, [title])
}
